<template>
    <div>
        <h2 class="u-padding-b-30">
            Preview and update the discount rate on a single or multiple claims
        </h2>

        <book-of-business-search></book-of-business-search>

        <button class="a-button a-button--small" @click="loadPreview()" :disabled="updateDiscountRate === null">
            Preview
        </button>
        <button class="a-button a-button--small" @click="reset()">Reset</button>

        <div v-if="loading" class="a-loader--results"></div>

        <div v-if="preview.data.length" style="margin: 20px 0 0;">
            Discount Rate Comparison based on {{ preview.total }} matching claims.
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import BookOfBusinessSearch from 'pages/discount-rate-comparison/components/update/BookOfBusinessSearch.vue';
    import DiscountRates from 'pages/discount-rate-comparison/components/form/DiscountRates.vue';
    import IndividualSearch from 'pages/discount-rate-comparison/components/form/IndividualSearch.vue';

    export default {
        name: 'page-form',
        components: {
            BookOfBusinessSearch,
            DiscountRates,
            IndividualSearch,
        },
        computed: {
            ...mapState('discountRateComparison', [
                'chosenRates',
                'results',
                'loading',
                'preview',
                'updateDiscountRate',
            ]),
            ...mapGetters('discountRateComparison', [
                'individualClaim',
            ]),
        },
        methods: {
            ...mapActions('discountRateComparison', [
                'loadPreview',
                'reset'
            ]),
        },
    }
</script>



// WEBPACK FOOTER //
// PageForm.vue?eadc7d7c